import type { DropdownCategoryListProps, ResultProps, CarModelProps, ModelYearProps, PaginationProps, PushNotificationProps, DetailPuhsNotificationProps, TargetOptionProps } from "modules/types";
import CONSTANT from "modules/constant";
import { API, download, headers } from "./api";

const PushNotificationAPI = API.injectEndpoints({
    endpoints: (builder) => ({
        getPushNotificationMemberTierDropdown: builder.mutation<DropdownCategoryListProps[], void>({
            query: () => ({
                url: CONSTANT.URL_PUSH_NOTIFICATION_MEMBER_TIER_DROPDOWN,
                method: 'GET',
                headers: headers()
            })
        }),
        getPushNotificationCarModelDropdown: builder.mutation<CarModelProps[], void>({
            query: () => ({
                url: CONSTANT.URL_PUSH_NOTIFICATION_CAR_MODEL_DROPDOWN,
                method: 'GET',
                headers: headers()
            })
        }),
        getPushNotificationModelYearDropdown: builder.mutation<ModelYearProps[], void>({
            query: () => ({
                url: CONSTANT.URL_PUSH_NOTIFICATION_MODEL_YEAR_DROPDOWN,
                method: 'GET',
                headers: headers()
            })
        }),
        getPushNotificationTargetOptionDropdown: builder.mutation<TargetOptionProps[], void>({
            query: () => ({
                url: CONSTANT.URL_PUSH_NOTIFICATION_TARGET_OPTION_DROPDOWN,
                method: 'GET',
                headers: headers()
            })
        }),
        createPushNotification: builder.mutation<ResultProps, FormData>({
            query: (body) => ({
                url: CONSTANT.URL_PUSH_NOTIFICATION_CREATE,
                method: 'POST',
                headers: headers({ useContentType: false }),
                body: body,
                formData: true
            })
        }),
        getPushNotificationList: builder.mutation<PaginationProps<PushNotificationProps>, FormData>({
            query: (body) => ({
                url: CONSTANT.URL_PUSH_NOTIFICATION_LIST,
                method: 'POST',
                headers: headers({ useContentType: false }),
                body: body,
                formData: true
            })
        }),
        getPushNotificationDetail: builder.query<DetailPuhsNotificationProps, string | number>({
            query: (id) => ({
                url: CONSTANT.URL_PUSH_NOTIFICATION_DETAIL + `/${id}`,
                method: 'GET',
                headers: headers()
            })
        }),
        downloadPushNotificationList: builder.mutation<PaginationProps<PushNotificationProps>, FormData>({
            query: (body) => ({
                url: CONSTANT.URL_PUSH_NOTIFICATION_DOWNLOAD,
                method: 'POST',
                headers: headers({ useContentType: false }),
                body: body,
                responseHandler: download,
                formData: true
            })
        }),
        updatePushNotification: builder.mutation<ResultProps, FormData>({
            query: (body) => ({
                url: CONSTANT.URL_PUSH_NOTIFICATION_UPDATE,
                method: 'POST',
                headers: headers({ useContentType: false }),
                body: body,
                formData: true
            })
        }),
        deletePushNotification: builder.mutation<ResultProps, {id: number}>({
            query: (body) => ({
                url: CONSTANT.URL_PUSH_NOTIFICATION_DELETE + `/${body.id}`,
                method: 'DELETE',
                headers: headers(),
                body: {}
            })
        }),
        updateSchedulePushNotification: builder.mutation<unknown, {id: number[]}>({
            query: (body) => ({
                url: CONSTANT.URL_PUSH_NOTIFICATION_UPDATE_SCHEDULE,
                method: 'POST',
                headers: headers(),
                body: body
            })
        })
    })
})

export const {
    useGetPushNotificationMemberTierDropdownMutation,
    useGetPushNotificationCarModelDropdownMutation,
    useGetPushNotificationModelYearDropdownMutation,
    useGetPushNotificationTargetOptionDropdownMutation,
    useCreatePushNotificationMutation,
    useGetPushNotificationListMutation,
    useDownloadPushNotificationListMutation,
    useDeletePushNotificationMutation,
    useUpdateSchedulePushNotificationMutation,
    useGetPushNotificationDetailQuery,
    useUpdatePushNotificationMutation
} = PushNotificationAPI